export const APP_BASE = "/app";
export const CLASSIC_APP_BASE = "/app-classic";
export const PREVIEW_APP_BASE = "/app-preview";

export const APP_ROUTES = {
  dashboard: APP_BASE,
  alerts: `${APP_BASE}/alerts`,
  integrations: `${APP_BASE}/integrations`,
  hosts: `${APP_BASE}/hosts`,
  investigation: `${APP_BASE}/investigation`,
  msp: `${APP_BASE}/msp`,
  usage: `${APP_BASE}/usage`,
  settings: `${APP_BASE}/settings`,
  compliance: `${APP_BASE}/compliance`,
  emailAuth: `${APP_BASE}/email-auth`,
  threatIntel: `${APP_BASE}/threat-intel`,
  vulnerabilities: `${APP_BASE}/vulnerabilities`,
  cloudPosture: `${APP_BASE}/cloud-posture`,
  logs: `${APP_BASE}/logs`,
  executive: `${APP_BASE}/executive`,
  superadmin: `${APP_BASE}/superadmin`,
  superadminTenants: `${APP_BASE}/superadmin/tenants`,
  superadminUsers: `${APP_BASE}/superadmin/users`,
} as const;

/**
 * Translate a legacy authenticated-app URL to its canonical `/app` URL.
 * The suffix is intentionally opaque so nested paths continue to work as
 * they are introduced. Search parameters and hashes are retained verbatim.
 */
export function canonicalAppLocation(
  pathname: string,
  search = "",
  hash = "",
  legacyBase = PREVIEW_APP_BASE,
): string {
  const suffix = pathname === legacyBase ? "" : pathname.slice(legacyBase.length);
  return `${APP_BASE}${suffix}${search}${hash}`;
}

export function isAppPathActive(pathname: string, target: string): boolean {
  if (target === APP_BASE) {
    return pathname === APP_BASE || pathname === `${APP_BASE}/`;
  }
  return pathname === target || pathname.startsWith(`${target}/`);
}

/** Keep links inside the temporary classic fallback when it is active. */
export function appRouteForPathname(pathname: string, canonicalRoute: string): string {
  const basePath =
    pathname === CLASSIC_APP_BASE || pathname.startsWith(`${CLASSIC_APP_BASE}/`)
      ? CLASSIC_APP_BASE
      : APP_BASE;
  const suffix = canonicalRoute === APP_BASE ? "" : canonicalRoute.slice(APP_BASE.length);
  return `${basePath}${suffix}`;
}
